module.exports = __webpack_public_path__ + "static/media/diastole.b9ff3192.svg";